export default __webpack_public_path__ + "static/media/cross.54b0994a.svg";